// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* \nесли захотим прятать обрамление moveable\n.moveable-line {\n      display: none;\n}\n.moveable-origin {\n      display: none;\n} */\n", ""]);
// Exports
module.exports = exports;
